export const LIST_NAME = 'APS_BY_ACTIVITY_TAG'
